// extracted by mini-css-extract-plugin
module.exports = {"title":"employeeGuide_title__3TDrp","description":"employeeGuide_description__3-bgH"};